// Ambyrtek: view transitions disabled for stable native product gallery rendering.
// Navigation and all Shopify theme functionality continue normally.
(function () {
  document.getElementById('view-transition-render-blocker')?.remove();
})();
